import { IColumn } from '../interfaces/IContentTable';
import { BuildPath } from '../helpers/Paths';

function columnsContentPop():IColumn[]{
    return (
        [
            {
                label:'id',
                field:'id',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'image',
                field:'image',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'title',
                field:'title',
                sortable:false,
                display:false,
                order:null,
                maxChars:15
            },
            {
                label:'Workspace',
                field:'channel',
                sortable:false,
                display:true,
                order:null,
                maxChars:6
            },
            {
                label:'Widget',
                field:'widget',
                sortable:false,
                display:true,
                order:null,
                maxChars:6
            },
            {
                label:'Views',
                field:'views',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/Audience.svg`
            },
            {
                label:'Likes',
                field:'likes',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/Likes.svg`
            },
            {
                label:'Comments',
                field:'comments',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/Comments.svg`
            }
        ]    
    )
} 

function columnsContentPopRankings():IColumn[]{
    return (
        [
            {
                label:'id',
                field:'id',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'image',
                field:'image',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'title',
                field:'title',
                sortable:false,
                display:false,
                order:null,
                maxChars:15 
            },
            {
                label:'Widget',
                field:'widget',
                sortable:false,
                display:true,
                order:null,
                maxChars:6
            },
            {
                label:'Views',
                field:'views',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/Audience.svg`
            },
            {
                label:'Unique Views',
                field:'uniqueViews',
                sortable:true,
                display:true,
                order:null,
                maxChars:6,
                icon:`${BuildPath()}/images/insightsp2/UniqueViews.svg`
            },
            {
                label:'Likes',
                field:'likes',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/Likes.svg`
            },
            {
                label:'Comments',
                field:'comments',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/Comments.svg`
            }
        ]    
    )
} 

function columnsUserGroup():IColumn[] { 
    return (
        [
            {
                label:'id',
                field:'id',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'title',
                field:'title',
                sortable:false,
                display:false,
                order:null,
                maxChars:15
            },
            {
                label:'Users',
                field:'userCount',
                sortable:true,
                display:true,
                order:null,
                maxChars:6,
                icon:`${BuildPath()}/images/insightsp2/user.svg`
            },
            {
                label:'Unique Views',
                field:'uniqueViews',
                sortable:true,
                display:true,
                order:null,
                maxChars:6,
                icon:`${BuildPath()}/images/insightsp2/UniqueViews.svg`
            },
            {
                label:'Likes',
                field:'likes',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/Likes.svg`
            },
            {
                label:'Comments',
                field:'comments',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/Comments.svg`
            },
            {
                label:'Recognition Posts',
                field:'recognitionPosts',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/PeopleThanked.svg`
            },
            {
                label:'UGC Posts',
                field:'ugcPosts',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/UGC.svg`
            },
            {
                label:'Acknowledgements',
                field:'acknowledgements',
                sortable:true,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/CompliantPosts.svg`
            }
        ]
    )
}

function columnsUserGroupLogin():IColumn[] { 
    return (
        [
            {
                label:'id',
                field:'id',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'title',
                field:'title',
                sortable:false,
                display:false,
                order:null,
                maxChars:25
            },
            {
                label:'Users in group',
                field:'userCount',
                sortable:false,
                display:true,
                order:null,
                icon:`${BuildPath()}/images/insightsp2/user.svg`
            },
            {
                label:'Logged in',
                field:'loggedInPercentage',
                sortable:true,
                display:true,
                order:null
            }
        ]
    )
}

function columnsListPop():IColumn[] {
    return (
        [
            {
                label:'id',
                field:'id',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'image',
                field:'image',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'title',
                field:'title',
                sortable:false,
                display:false,
                order:null,
                maxChars:10
            },
            {
                label:'Views',
                field:'views',
                sortable:true,
                display:true,
                order:null,
                maxChars:6,
                icon:`${BuildPath()}/images/insightsp2/Audience.svg`
            },
            {
                label:'Unique Views',
                field:'uniqueviews',
                sortable:true,
                display:true,
                order:null,
                maxChars:6,
                icon:`${BuildPath()}/images/insightsp2/UniqueViews.svg`
            }
           
        ]
    )
}

function columnsChanPop():IColumn[] {
    return (
        [
            {
                label:'id',
                field:'id',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'image',
                field:'image',
                sortable:false,
                display:false,
                order:null
            },
            {
                label:'title',
                field:'title',
                sortable:false,
                display:false,
                order:null,
                maxChars:10
            },
            {
                label:'Users',
                field:'userCount',
                sortable:true,
                display:true,
                order:null,
                maxChars:6,
                icon:`${BuildPath()}/images/insightsp2/user.svg`
            },
            {
                label:'Views',
                field:'views',
                sortable:true,
                display:true,
                order:null,
                maxChars:6,
                icon:`${BuildPath()}/images/insightsp2/Audience.svg`
            }
        ]
    )
}

export {columnsContentPop, columnsUserGroup, columnsListPop, columnsChanPop, columnsUserGroupLogin, columnsContentPopRankings}